import ajax from '../utils/request.js'
import qs from 'qs'
import store from '../store'

const defaultParams = (params) => {
  return {
    apiKey: store.state.apiKey,
    ...params
  }
}

export const getCityHk = params => {
  return ajax.post('hk-gateway/hk-project/merchant/listCity', JSON.stringify(params), {
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export const sendCode = params => {
  return ajax.post('hk-gateway/hk-auth/auth/getCaptcha', JSON.stringify(defaultParams(params)), {
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export const registPhone = params => {
  return ajax.post('hk-gateway/hk-auth/auth/checkCaptcha', JSON.stringify(params), {
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export const getUserInfo = params => {
  return ajax.post('hk-gateway/hk-auth/auth/getUserInfo', JSON.stringify(params), {
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export const checkLogin = params => {
  return ajax.post('hk-gateway/hk-auth/auth/checkLogin', JSON.stringify(params), {
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export const getRestaurant = params => {
  return ajax.post('hk-gateway/hk-project/merchant/list', JSON.stringify(params), {
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export const getRightDetail = params => {
  return ajax.post('hk-gateway/hk-project/merchant/detail',  JSON.stringify(params), {
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export const verifyCard = params => {
  return ajax.post('hk-gateway/hk-project/order/verifyCardBin',  JSON.stringify(params), {
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export const verifyPayType = params => {
  return ajax.post('hk-gateway/hk-project/order/preOrderVerify',  JSON.stringify(params), {
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export const orderMainList = params => {
  return ajax.post('hk-gateway/hk-project/order/orderList',  JSON.stringify(defaultParams(params)), {
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export const rightCancel = params => {
  return ajax.post('hk-gateway/hk-project/order/cancelOrder', JSON.stringify(defaultParams(params)), {
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export const rightSell = params => {
  return ajax.post('hk-gateway/hk-project/order/order',  JSON.stringify(defaultParams(params)), {
    headers: {
      'Content-Type': 'application/json'
    }
  })
}


export const getArea = params => {
  return ajax.get('atc-core/wx/home/areaList', params)
}

export const getCountry = params => {
	return ajax.get('atc-core/wx/home/countryList', params)
}

export const getCity = params => {
	return ajax.get('atc-core/wx/home/cityList', params)				// -> SearchCity.vue
}

export const getHotelRoom = params => {
	return ajax.post('atc-core/wx/hotel/liveSearchForMany_v2', qs.stringify(params))
}

export const getHotelDetail = params => {
	return ajax.post('atc-core/wx/hotel/hotelDetail', qs.stringify(params))
}

export const getRoomPrice = params => {
	return ajax.post('atc-core/wx/hotel/enhancedPricing_v2', qs.stringify(params))
}

export const getBrand = params => {
	return ajax.get('atc-core/wx/home/dictQuery', params)
}

export const submitHotel = params => {
	return ajax.get('atc-core/wx/hotel/hotelSell', params)
}

export const getRoomInfo = params => {
	return ajax.post('atc-core/wx/hotel/liveSearch_v2', qs.stringify(params))
}


export const getRightList = params => {
  return ajax.post('atc-core/DFS/commonSearchRights',  qs.stringify(params))
}

export const getHotRight = params => {
  return ajax.post('atc-core/DFS/getHotRight',  qs.stringify(params))
}






export const loginThird = params => {
  return ajax.post('atc-core/wx/masterCardSport/loginByMasterCard',  qs.stringify(params))
}

export const hotelSell = params => {
  return ajax.post('atc-core/wx/hotel/hotelSell_V2',  qs.stringify(params))
}



export const getUserAccept = params => {
  return ajax.post('atc-core/DFS/getUserAccept',  qs.stringify(params))
}

export const acceptNote = params => {
  return ajax.post('atc-core/DFS/acceptNote',  qs.stringify(params))
}

export const getRightCity = params => {
  return ajax.post('atc-core/DFS/getRightCity',  qs.stringify(params))
}

export const keyWordSearch = params => {
  return ajax.post('atc-core/DFS/keyWordSearch',  qs.stringify(params))
}

export const getDict = params => {
  return ajax.get('atc-core/wx/home/dictQuery', params)
}

export const pnrCancel = params => {
  return ajax.post('atc-core/wx/hotel/pnrCancel_v2', qs.stringify(params))
}



export const getCountryByRegion = params => {
  return ajax.get('atc-core/wx/masterCardRes/getCountryList', params)
}








export const adyenPayment = params => {
  return ajax.post('adyen/payment', qs.stringify(params))
}

const uploadFile = process.env.UPLOAD_PATH + "hk-gateway/hk-project/order/uploadImg"
export {uploadFile}


// WEBPACK FOOTER //
// ./src/service/http.js